import React from "react";
import { CheckIcon } from "@heroicons/react/solid";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function ProgressBar({ step, setStep, barSteps, petType }) {
  const selectStep = (stepNum, status) => {
    if (status === "complete" || status === "current") {
      setStep(stepNum);
    }
  };

  // Hide the Contact step (stepNum 4) from the progress bar display
  const visibleSteps = barSteps.filter((s) => s.stepNum !== 4);

  return (
    <div className="flex justify-center h-10 sm:h-16 items-center sm:items-start sm:pt-4 bg-[#D98B6F] backdrop-blur-sm border-b border-gray-100 w-full z-20 md:rounded-t-[2rem] rounded-b-[2rem] md:px-4">
      <nav aria-label="Progress" className="w-full max-w-xl px-4 pr-10 sm:pr-12">
        <ol role="list" className="flex items-center justify-between w-full">
          {visibleSteps.map((barStep, stepIdx) => (
            <li
              key={barStep.name}
              className={classNames(
                stepIdx !== visibleSteps.length - 1 ? "flex-1" : "",
                "relative flex items-center"
              )}
            >
              {barStep.status === "complete" ? (
                <>
                  <div className="absolute inset-0 flex items-center" aria-hidden="true">
                    <div className="h-0.5 w-full bg-white/25" />
                  </div>
                  <a
                    onClick={() => selectStep(barStep.stepNum, barStep.status)}
                    className="relative w-3 h-3 sm:w-3.5 sm:h-3.5 flex items-center justify-center bg-kito-green rounded-full hover:bg-opacity-80 cursor-pointer shadow-sm"
                  >
                    <span className="sr-only">{barStep.name}</span>
                    <span className="hidden sm:block absolute top-5 left-1/2 -translate-x-1/2 text-[10px] font-poppins font-medium text-white whitespace-nowrap">
                      {barStep.name}
                    </span>
                  </a>
                </>
              ) : barStep.status === "current" ? (
                <>
                  <div className="absolute inset-0 flex items-center" aria-hidden="true">
                    <div className="h-0.5 w-full bg-white/25" />
                  </div>
                  <a
                    onClick={() => selectStep(barStep.stepNum, barStep.status)}
                    className="relative w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center bg-white border-2 border-kito-green rounded-full z-10 shadow-sm"
                    aria-current="step"
                  >
                    <span className="h-1.5 w-1.5 sm:h-2 sm:w-2 bg-kito-green rounded-full" aria-hidden="true" />
                    <span className="sr-only">{barStep.name}</span>
                    <span className="hidden sm:block absolute top-6 left-1/2 -translate-x-1/2 text-[10px] font-poppins font-bold text-white whitespace-nowrap">
                      {barStep.name}
                    </span>
                  </a>
                </>
              ) : (
                <>
                  <div className="absolute inset-0 flex items-center" aria-hidden="true">
                    <div className="h-0.5 w-full bg-white/25" />
                  </div>
                  <a className="group relative w-2.5 h-2.5 sm:w-3 sm:h-3 flex items-center justify-center bg-[#E8B9A8] rounded-full z-10">
                    <span className="sr-only">{barStep.name}</span>
                    <span className="hidden sm:block absolute top-5 left-1/2 -translate-x-1/2 text-[10px] font-poppins font-medium text-white/60 whitespace-nowrap">
                      {barStep.name}
                    </span>
                  </a>
                </>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </div>
  );
}

export default ProgressBar;
